exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.container[data-v-49db4088] {\n  width: 100%;\n  margin: 0 auto;\n  padding: 0;\n  background: #000000;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-49db4088&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/layouts/Origami.vue
// module id = 73
// module chunks = 0